import { ReactNode, MouseEventHandler } from "react";
import { Box, Button } from "@mui/material";
import { useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";
import "./styles.scss";
import { ActionLink } from "../ActionLink";
import { IconComponent } from "../IconComponent";
import { MobilePopoverCard } from "../MobilePopoverCard";
import { IconName } from "../Icon";

export interface IActionModalProps {
  className: string;
  children?: ReactNode;
  onClose: () => void;
  onClick: MouseEventHandler<Element>;
  open: boolean;
  buttonLabel: string;
  disabled: boolean;
}

export const ActionModal = (props: IActionModalProps) => {
  const { className, onClose, onClick, children, open, buttonLabel, disabled } =
    props;

  const { t } = useI18nContext();

  return (
    <MobilePopoverCard
      open={open}
      onClose={onClose}
      fullScreen={false}
      className={`${className} action-modal-popover`}
      contentClassName="action-modal-wrapper"
      topRightButton={
        <ActionLink
          className="filter-close-button"
          content={
            <IconComponent
              ariaLabel={t("modalClose.ariaLabel")}
              className={clsx("close-button-icon")}
              name={IconName.Close}
            />
          }
          label={t("modalClose.label")}
          onClick={onClose}
        />
      }
    >
      <Box className={clsx("action-modal-root")}>
        {children}
        <div className={clsx("action-modal-button-container")}>
          <Button
            className={clsx("action-modal-button", disabled && "disabled")}
            onClick={onClick}
            fullWidth={true}
            variant="outlined"
            size="large"
            disabled={disabled}
          >
            {buttonLabel}
          </Button>
        </div>
      </Box>
    </MobilePopoverCard>
  );
};

export default ActionModal;
